module.exports = __webpack_public_path__ + "img/big_eye_chart.a154eab2.jpg";